<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Enquiry </h1>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- ABOUT
        ================================================== -->
<section class="overflow-hidden position-relative about-style-03 bg-light-yellow" id="aboutus">
    <div class="container">
        <div class="row align-items-center position-relative z-index-9">


            <div class="col-lg-12 col-xxl wow fadeInUp" data-wow-delay="200ms">
                <div class="text-center">
                    <div class="section-title-04 mb-5 position-relative text-center">
                        <span class="sm-title">Enquiry </span>
                        <h2 class="display-16 lh-1 mb-0">
                            Thank you
                        </h2>

                    </div>
                    <p class="mb-1-5">
                        Thank you for your enquiry. Our Team will get in touch with you shortly.
                    </p>

                    <p class="mb-1-5">
                        &nbsp;
                    </p>
                    <p class="mb-1-5">
                        &nbsp;
                    </p>
                    <p class="mb-1-5">
                        &nbsp;
                    </p>
                    <p class="mb-1-5">
                        &nbsp;
                    </p>
                    <p class="mb-1-5">
                        &nbsp;
                    </p>


                    <!-- <div class="position-relative">
                  <a href="" class="btn-style1"><span>Discover more </span></a>
                </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- <div
          class="position-absolute bottom-n5 bottom-xxl-5 right-n15 right-xxl-n5 ani-top-bottom d-none d-md-block"
        >
          <img src="img/content/shape-09.png" alt="..." />
        </div> -->
</section>
